"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_fns_1 = __importDefault(require("@date-io/date-fns"));
var AccessTime_1 = __importDefault(require("@material-ui/icons/AccessTime"));
var pickers_1 = require("@material-ui/pickers");
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var FormTimePicker = function (_a) {
    var fields = _a.fields, item = _a.item, values = _a.values, setFieldValue = _a.setFieldValue, changeField = _a.changeField, errors = _a.errors;
    return (react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: date_fns_1.default },
        react_1.default.createElement(pickers_1.TimePicker, { inputVariant: (item === null || item === void 0 ? void 0 : item.variant) || "outlined", fullWidth: true, disabled: item.disabled || false, id: item.idHtml || item.stateKey, label: item.label, ampm: item.ampm, format: "HH:mm", value: fields
                ? lodash_1.get(fields, item.stateKey, Date.now())
                : lodash_1.get(values, item.stateKey, Date.now()), onChange: function (e) {
                if (setFieldValue)
                    setFieldValue(item.stateKey, e || "");
                if (changeField)
                    changeField({
                        key: item.stateKey,
                        value: e || "",
                    });
            }, error: !!lodash_1.get(errors, item.stateKey, null) ||
                !!lodash_1.get(errors, item.error, null), helperText: lodash_1.get(errors, item.stateKey, null) ||
                lodash_1.get(errors, item.error, null), InputProps: {
                endAdornment: react_1.default.createElement(AccessTime_1.default, null),
            }, variant: "dialog", okLabel: item.okLabel, clearLabel: item.clearLabel, cancelLabel: item.cancelLabel })));
};
exports.default = FormTimePicker;
//# sourceMappingURL=GenericFormTimePicker.js.map